<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" class="icon icon-tabler icon-tabler-photo" viewBox="0 0 24 24">
    <path stroke="none" d="M0 0h24v24H0z"/>
    <path d="M15 8h.01"/>
    <rect width="16" height="16" x="4" y="4" rx="3"/>
    <path d="M4 15l4-4a3 5 0 013 0l5 5"/>
    <path d="M14 14l1-1a3 5 0 013 0l2 2"/>
  </svg>
</template>